import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'date-range-filter',
  templateUrl: './date-range-filter.component.html',
  styleUrls: ['./date-range-filter.component.scss'],
})
export class DateRangeFilterComponent implements OnInit {
  selectedOption: string;
  currentMonth: string;
  currentDate: string;
  maxMonth: string;
  maxDate: string;
  selectedFilters: any;
  dateRange: { from: string; to: string } = { from: '', to: '' };
  dateTypeToFnMap: Map<string, any> = new Map([
    ['month', this.setCurrentMonth],
    ['date', this.setCurrentDate],
    ['dateRange', this.setDateRange],
  ]);

  @Output() onOptionChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {
    this.selectedOption = 'month';
    this.setCurrentDate();
    this.setCurrentMonth();
    this.maxDate = this.currentDate;
    this.maxMonth = this.currentMonth;
    this.setDateRange();
    this.optionChanged(this.selectedOption, this.currentMonth);
  }

  setCurrentDate(preSelectedDate: Date = new Date()) {
    const today = preSelectedDate;
    const month = today.getMonth() + 1;
    const day = today.getDate();
    this.currentDate = `${today.getFullYear()}-${month < 10 ? '0' : ''}${month}-${
      day < 10 ? '0' : ''
    }${day}`;
  }

  setCurrentMonth(preSelectedMonth: Date = new Date()) {
    const today = preSelectedMonth;
    const month = today.getMonth() + 1;
    this.currentMonth = `${today.getFullYear()}-${month < 10 ? '0' : ''}${month}`;
  }

  setDateRange(preSelectedRange: Date = new Date()) {
    const today = preSelectedRange;
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const fromYear = firstDayOfMonth.getFullYear();
    const fromMonth = firstDayOfMonth.getMonth() + 1;
    const fromDay = firstDayOfMonth.getDate();

    const toYear = today.getFullYear();
    const toMonth = today.getMonth() + 1;
    const toDay = today.getDate();

    this.dateRange.from = `${fromYear}-${fromMonth < 10 ? '0' : ''}${fromMonth}-${
      fromDay < 10 ? '0' : ''
    }${fromDay}`;

    this.dateRange.to = `${toYear}-${toMonth < 10 ? '0' : ''}${toMonth}-${
      toDay < 10 ? '0' : ''
    }${toDay}`;
  }

  optionChanged(option: string, value: any) {
    this.onOptionChange.emit({ option, value, invalid: this.isDateFilterInvalid(option, value) });
  }

  isDateFilterInvalid(option: string, value: any): boolean {
    if (option === 'month') {
      return !value || value > this.maxMonth;
    }

    if (option === 'date') {
      return !value || value > this.maxDate;
    }

    if (option === 'dateRange') {
      return !value ||
        !value.from ||
        !value.to ||
        value.from > value.to ||
        value.from > this.maxDate ||
        value.to > this.maxDate;
    }

    return false;
  }
}
